import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, InjectionToken, Injector } from '@angular/core';
import { ComponentPortal, DomPortalOutlet, PortalInjector } from '@angular/cdk/portal';
import { TooltipPopoutData } from './tooltip-help.service';
import { TooltipHelpComponent } from 'app/components/popout-modals/tooltip-help/tooltip-help.component';

export interface PopoutModalData {
	modalName: string; // unique value that point the the specific window
	modalWindowName: string; // The window name to show when hover over

	onWindowClose?: (e) => any;
}
export const TOOLTIP_POPOUT_MODAL_DATA = new InjectionToken<TooltipPopoutData>('TOOLTIP_POPOUT_MODAL_DATA');

@Injectable({
  providedIn: 'root'
})
export class PopoutModalService {
// Reference: https://medium.com/@saranya.thangaraj/open-angular-component-in-a-new-tab-without-bootstrapping-the-whole-app-again-e329af460e92
// https://stackblitz.com/edit/portal-simple-yym4zy?file=src%2Fapp%2Fapp.component.ts,src%2Fapp%2Fservices%2Fpopout.tokens.ts,src%2Fapp%2Fservices%2Fpopout.service.ts,src%2Fapp%2Fcustomer%2Fcustomer.component.ts,src%2Fapp%2Fcustomer%2Fcustomer.component.html,src%2Fapp%2Fapp.module.ts

	popoutModals: {
		[modalName: string]: Window
	} = {};

	styleSheetElement;
	constructor(
		private injector: Injector,
		private componentFactoryResolver: ComponentFactoryResolver,
		private applicationRef: ApplicationRef
	) { }

	openPopoutModal(data: PopoutModalData) {
		const windowInstance = this.openOnce('assets/modal/popout.html', `${data.modalWindowName}`);
		this.popoutModals[data.modalName] = windowInstance;
		// Wait for window instance to be created
		setTimeout(() => {
			if (data.onWindowClose) {
				windowInstance.addEventListener('beforeunload', (e) => {
					data.onWindowClose(e);
				});
			}
			this.createCDKPortal(data, windowInstance);
		}, 1000);
	}


	openOnce(url, target) {
		// open a blank "target" window
		// or get the reference to the existing "target" window
		const winRef = window.open('', target, 'height=600,width=800');
		// if the "target" window was just opened, change its url
		if (winRef.location.href === 'about:blank') {
			winRef.location.href = url;
		}
		return winRef;
	}
	private createCDKPortal(data, windowInstance: Window) {
		if (windowInstance) {
			windowInstance.document.body.innerText = '';
			// Create a portal outlet with the body of the new window document
			const outlet = new DomPortalOutlet(windowInstance.document.body, this.componentFactoryResolver, this.applicationRef, this.injector);

			// Copy styles from parent window
			Array.from(document.querySelectorAll('style')).forEach(htmlElement => {
				windowInstance.document.head.appendChild(htmlElement.cloneNode(true));
			});
			// Copy stylesheet link from parent window
			this.styleSheetElement = this.getStyleSheetElement();
			windowInstance.document.head.appendChild(this.styleSheetElement);

			// this.styleSheetElement.onload = () => {
				// Clear popout modal content
				windowInstance.document.body.innerText = '';

				// Create an injector with modal data
				const injector = this.createInjector(TOOLTIP_POPOUT_MODAL_DATA, data); // TODO

				// Attach the portal
				let componentInstance;
				if (data.modalName === 'tooltipHelp') {
					windowInstance.document.title = 'Customer Modal';
					componentInstance = this.attachTooltipContainer(outlet, injector);
				}
			// };
		}
	}

	isPopoutOpen(modalName: string) {
		return this.popoutModals[modalName] && !this.popoutModals[modalName].closed;
	}
	focusPopoutWindow(modalName: string) {
		this.popoutModals[modalName].focus();
	}
	closePopoutModal(modalName: string) {
		this.popoutModals[modalName].close();
	}

	createInjector(popoutModalData: InjectionToken<any>, data) {
		const injectionTokens = new WeakMap();
		injectionTokens.set(popoutModalData, data);
		return new PortalInjector(this.injector, injectionTokens);
	}

	getStyleSheetElement() {
		const styleSheetElement = document.createElement('link');
		Array.from(document.querySelectorAll('link')).forEach(htmlElement => {
		if (htmlElement.rel === 'stylesheet') {
			const absoluteUrl = new URL(htmlElement.href).href;
			styleSheetElement.rel = 'stylesheet';
			styleSheetElement.href = absoluteUrl;
		}
		});
		console.log(styleSheetElement.sheet);
		return styleSheetElement;
	}

	attachTooltipContainer(outlet, injector) {
		const containerPortal = new ComponentPortal(TooltipHelpComponent, null, injector);
		const containerRef: ComponentRef<TooltipHelpComponent> = outlet.attach(containerPortal);
		return containerRef.instance;
	}
	
}
